import { render, staticRenderFns } from "./internationale-verhuizingen.vue?vue&type=template&id=01431dc6"
import script from "./internationale-verhuizingen.vue?vue&type=script&lang=js"
export * from "./internationale-verhuizingen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports